import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQueryOptions } from "@/api/queries/session";
import { defaultScope } from "@/lib/store-scope";

/** `/` → the overview in this browser's default scope (`/{storeId}/overview` or `/ALL/overview`). */
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions());
    if (!me) throw redirect({ to: "/login", search: { redirect: undefined } });
    throw redirect({ to: "/$store/overview", params: { store: defaultScope(me) } });
  },
});
